import React from "react";
import { FunctionComponent } from "react";
import { Jumbotron } from "react-bootstrap";
import { observer } from "mobx-react-lite";

interface ValidationCardProps {
  title: React.ReactNode;
  badges?: React.ReactNode;
}

const ValidationCard: FunctionComponent<ValidationCardProps> = observer((props) => {
  const { badges, title, children } = props;
  return (
    <Jumbotron className="col-12 py-4 mb-3">
      <div className="d-flex flex-row flex-wrap justify-content-between align-items-center mb-0">
        <h4 className="mb-1 mr-3">{title}</h4>
        <div className="d-flex flex-row align-content-end">{badges}</div>
      </div>
      {children && <hr className="mt-4 mb-4" />}
      {children}
    </Jumbotron>
  );
});

export default ValidationCard;
